import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';
import { _DeepPartialObject } from 'node_modules/chart.js/dist/types/utils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface Seance {
  sujet: string;
  fiable: boolean;
  sessionDate: string;
  // @ts-expect-error // Ignore TS error for dynamic properties
  parameters: { content: string }[]; // Fixed field for parameters
  resultsOB?: string | null;
  resultsOT?: string | null;
  resultsPVS?: string | null;
  resultsZPCCF?: string | null;
  resultsZPFCF?: string | null;
  resultsZPI?: string | null;
  resultsZPL?: string | null;
  [key: string]: string | number | boolean | null | undefined; // Allow other dynamic properties
}





const SeanceGraph = ({ seances, selectedExercise }: { seances: Seance[], selectedExercise: string }) => {
  const data = {
    labels: seances.map((seance) => "N°" + seance.order + " " + new Date(seance.sessionDate).toLocaleDateString()),
    datasets: [
      {
        label: `Résultats pour ${selectedExercise}`,
        data: seances.map(seance => {
          const result = seance[selectedExercise];

          // Handle success/failure counts for ZPFCF and ZPCCF
          if (selectedExercise === "resultsZPFCF" || selectedExercise === "resultsZPCCF") {
            if (result && typeof result === 'string') {
              try {
                const parsedResult = JSON.parse(result); // Parse the result string
                const { successCount, failureCount } = parsedResult;
                if (typeof successCount === 'number' && typeof failureCount === 'number') {
                  const total = successCount + failureCount;
                  return total > 0 ? (successCount / total) * 100 : 0; // Percentage success
                }
              } catch (error) {
                console.error("Failed to parse result:", error);
              }
            }
          }

          // Default case: return the result directly or 0 if not available
          return result !== null && !isNaN(Number(result)) ? parseFloat(String(result)) : 0;
        }),
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        tension: 0.4
      }
    ]
  };

  const options: _DeepPartialObject<ChartOptions<'line'>> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Séances (chronologique)'
        }
      },
      y: {
        max: selectedExercise === "resultsZPFCF" || selectedExercise === "resultsZPCCF" ? 100 : 10,
        title: {
          display: true,
          text: selectedExercise === "resultsZPFCF" || selectedExercise === "resultsZPCCF" ? 'Pourcentage (%)' : 'Résultats'
        },
        beginAtZero: true,
        ticks: {
        }
      }
    }
  };

  return (
    <div className="w-full h-64">
      <Line data={data} options={options} />
    </div>
  );
};

export default SeanceGraph;
